<template>
  <div class="d-flex flex-column align-items-center  col-12 page-wrapper">
    <!-- Success State -->
    <div v-if="subscriptionStatus === 'success'" class="d-flex flex-column align-items-center col-12">
      <img :src="require(`../../brand/${this.brandConfig.brand}/assets/evina-img.webp`)" class="w-100">
      <div class="header-text mt-3">
        Success!
      </div>
      <div class="sub-header-text mt-1">
        Thank you for joining {{ this.brandConfig.tabTitle }}!
      </div>

      <!-- Cross-sell Section -->
<!--      <div v-if="crossSellConfig" class="d-flex flex-column upsell-container col-11 pb-2">-->
<!--        <img-->
<!--            v-if="crossSellConfig.imageUrl"-->
<!--            :src="crossSellConfig.imageUrl"-->
<!--            class="h-100"-->
<!--            alt="Cross-sell banner"-->
<!--        >-->
<!--        <div class="d-flex flex-column justify-content-center">-->
<!--          <div class="d-flex mt-3">-->
<!--            <span class="header-text mx-2">{{ crossSellConfig.headerText }}</span>-->
<!--            <div class="free-text-container ms-auto d-flex justify-content-center align-items-center free-text mx-2">-->
<!--              Free for 24 Hours-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="d-flex justify-content-center sub-header-text mt-1">-->
<!--            {{ crossSellConfig.subHeaderText }}-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="d-flex justify-content-center sub-header-text">-->
<!--          <button-->
<!--              class="accept-btn"-->
<!--              @click="handleCrossSellSubscription"-->
<!--              :disabled="isCrossSellLoading"-->
<!--          >-->
<!--            {{ isCrossSellLoading ? 'PROCESSING...' : 'JOIN NOW' }}-->
<!--          </button>-->
<!--        </div>-->
<!--        <div class="d-flex justify-content-center disclaimer-text mt-1">-->
<!--          FREE for 24 hours, then 20 KSH/day. T&C's Apply.-->
<!--        </div>-->
<!--      </div>-->

      <span class="sub-header-text underline mt-3" @click="redirectToGame">
        Go to {{ this.brandConfig.tabTitle }}
      </span>
    </div>

    <!-- Error State -->
    <div v-else-if="subscriptionStatus === 'error'" class="error-container">
      <div class="error-icon">✕</div>
      <div class="header-text mt-3">
        Subscription Failed
      </div>
      <div class="sub-header-text mt-4">
        {{ errorDetails.message }}
      </div>
      <div class="error-code mt-2">
        Error Code: {{ errorDetails.code }}
      </div>
    </div>

    <!-- Loading State -->
    <div v-else class="loading-container">
      <div class="spinner"></div>
      <div class="header-text mt-3">
        Processing your subscription...
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import OnevasService from "@/services/onevasService";
import CampaignService from "@/services/campaignService";
import { triggerGTMEvent } from "@/functions/addGTM";
import { v4 as guid } from "uuid";
import {
  parseSubscriptionResponse,
  getErrorMessage,
  generateBasicAuth,
  getCrossSellConfig
} from "@/utils/subscriptionHelpers";
import { ethiotelConfig } from "@/config";
import parseTransactionId from "@/functions/parseTransactionId";

export default {
  data() {
    return {
      subscriptionStatus: 'loading', // 'loading', 'success', 'error'
      errorDetails: {
        code: null,
        message: null
      },
      correlationId: null,
      msisdn: null,
      code: null,
      message: null,
      crossSellConfig: null,
      isCrossSellLoading: false
    }
  },
  computed: {
    ...mapState(['brandConfig'])
  },
  methods: {
    parseUrlParams() {
      const urlParams = new URLSearchParams(window.location.search);

      this.correlationId = urlParams.get("correlationId") || urlParams.get("correlatorId");
      this.code = urlParams.get("code");
      this.message = urlParams.get("message");
      this.msisdn = urlParams.get("msisdn");

      return {
        correlationId: this.correlationId,
        code: this.code,
        message: this.message,
        msisdn: this.msisdn
      };
    },

    async handleSubscriptionResponse() {
      try {
        const params = this.parseUrlParams();
        // Check if subscription was successful based on code
        const response = parseSubscriptionResponse(params.code, params.message);
        if (!response.status === 'success') {
          // Handle error
          this.subscriptionStatus = 'error';
          this.errorDetails = {
            code: params.code,
            message: params.message || getErrorMessage(params.code)
          };
          return;
        }

        // Success - Upsert user as ACTIVE
        console.log('=== Processing Successful Subscription ===');

        if (params.correlationId) {
          try {
            await OnevasService.upsertUserViaProductId(
                params.correlationId,
                params.msisdn,
                this.brandConfig?.serviceId,
                this.brandConfig.productId,
                this.brandConfig?.campaignId,
                null,
            );
            console.log('✓ User upserted successfully');
            this.subscriptionStatus = 'success';
            // Load cross-sell configuration
            this.crossSellConfig = getCrossSellConfig(this.brandConfig.brand);
              // Redirect To Game
              this.redirectToGame();
          } catch (upsertError) {
            console.error('Error:', upsertError);
            console.error('Response:', upsertError.response);
            this.subscriptionStatus = 'success';

            setTimeout(() => {
              this.$router.push('/');
            }, 3000);
          }
        } else {
          console.warn('No correlation ID provided, skipping upsert');

          setTimeout(() => {
            this.$router.push('/');
          }, 3000);
        }
      } catch (error) {
        console.error('=== Fatal Error in handleSubscriptionResponse ===');
        console.error('Error:', error);

        this.subscriptionStatus = 'error';
        this.errorDetails = {
          code: -1,
          message: 'An unexpected error occurred. Please try again.'
        };
      }
    },

    async handleCrossSellSubscription() {
      if (!this.crossSellConfig) return;

      this.isCrossSellLoading = true;

      console.log('=== Cross-sell Subscription Initiated ===');
      console.log('Target Product:', this.crossSellConfig.brand);
      console.log('Target Product ID:', this.crossSellConfig.productId);
      console.log('Target Campaign ID:', this.crossSellConfig.campaignId);

      try {
        triggerGTMEvent('cross_sell_subscribe_button_clicked', {
          from_product: this.brandConfig.productId,
          to_product: this.crossSellConfig.productId
        });

        const urlParams = new URLSearchParams(window.location.search);
        const parsedTransactionId = parseTransactionId(urlParams.get('transaction_id'));
        const correlationId = guid().toString();

        // Get campaign config for cross-sell product
        const {
          clickIdParameterName,
          publisherIdParameterName,
        } = await CampaignService.getCampaignConfig(this.crossSellConfig.campaignId);

        const publisherId = urlParams.get(publisherIdParameterName) ?? urlParams.get('publisherId') ?? parsedTransactionId?.publisherId;
        const clickId = parsedTransactionId?.clickId ??
            urlParams.get(clickIdParameterName) ??
            urlParams.get('clickid') ??
            urlParams.get('clickId') ??
            urlParams.get('click_id') ??
            urlParams.get('ofreqid') ??
            urlParams.get('transaction_id') ??
            urlParams.get('pr_mbp_clickID');

        console.log('=== Cross-sell Outbound Data ===');
        console.log('Correlation ID:', correlationId);
        console.log('MSISDN:', this.msisdn);
        console.log('Product ID:', this.crossSellConfig.productId);
        console.log('Campaign ID:', this.crossSellConfig.campaignId);
        console.log('Publisher ID:', publisherId);
        console.log('Click ID:', clickId);
        console.log('==============================');

        // Queue subscription for cross-sell product
        await OnevasService.queueUserSubscription(
            correlationId,
            this.msisdn,
            this.crossSellConfig.productId,
            this.crossSellConfig.campaignId,
            clickId,
            publisherId,
            undefined,
            undefined
        );

        console.log('✓ Cross-sell subscription queued successfully');

        // Build redirect URL with all parameters
        const authorization = generateBasicAuth();
        const redirectUrl = `${ethiotelConfig.redirectUrl}?correlationId=${correlationId}&trxId=${correlationId}&mcc=${this.crossSellConfig.mcc}&mnc=${this.crossSellConfig.mnc}&spId=${this.crossSellConfig.spId}&serviceId=${this.crossSellConfig.serviceId}&productId=${this.crossSellConfig.productId}&authorization=${authorization}&entryChannel=Web`;

        console.log('=== Cross-sell Redirect URL ===');
        console.log(redirectUrl);
        console.log('==============================');

        window.location.href = redirectUrl;

      } catch (error) {
        console.error('=== Cross-sell Subscription Error ===');
        console.error('Error:', error);
        console.error('Response:', error.response);
        console.error('===================================');

        alert('Failed to process cross-sell subscription. Please try again.');
      } finally {
        this.isCrossSellLoading = false;
      }
    },

    redirectToGame() {
      const params = this.parseUrlParams();
      const gameUrl = `${this.brandConfig.gameUrl}?msisdn=${params.msisdn}`;
      console.log('=== Redirecting to Game ===');
      console.log('Game URL:', gameUrl);

      triggerGTMEvent('redirect_to_game', {
        game_url: gameUrl,
        product_id: this.brandConfig.productId
      });

      window.location.href = gameUrl;
    }
  },

  async mounted() {
    console.log('=== Thank You Page Mounted ===');
    triggerGTMEvent('thank_you_page_view');

    await this.handleSubscriptionResponse();
  }
}
</script>

<style scoped>
.page-wrapper {
  height: 100vh;
}

.error-container,
.loading-container {
  text-align: center;
  padding: 2rem;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 16px;
  backdrop-filter: blur(10px);
}

.error-icon {
  width: 80px;
  height: 80px;
  margin: 0 auto;
  background: #f44336;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 3rem;
  color: white;
  font-weight: bold;
}

.spinner {
  width: 60px;
  height: 60px;
  margin: 0 auto;
  border: 6px solid rgba(255, 255, 255, 0.3);
  border-top-color: white;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

.header-text {
  color: #FFFFFF;
  text-align: center;
  font-size: 1.5rem;
  font-weight: bold;
}

.sub-header-text {
  color: #FFFFFF;
  text-align: center;
  font-size: 1rem;
  opacity: 0.9;
}

.sub-header-text.underline {
  text-decoration: underline;
  cursor: pointer;
}

.error-code {
  color: #FFFFFF;
  text-align: center;
  font-size: 0.9rem;
  opacity: 0.8;
  font-family: monospace;
}

.upsell-container {
  background: #424242;
  border-radius: 12px;
  margin-top: 2rem;
  padding: 1rem;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
}

.free-text-container {
  background: #4CAF50;
  border-radius: 20px;
  padding: 0.3rem 0.8rem;
}

.free-text {
  color: white;
  font-size: 0.8rem;
  font-weight: bold;
}

.accept-btn {
  width: 90%;
  padding: 12px;
  margin-top: 1rem;
  background-color: limegreen;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s;
}

.accept-btn:hover:not(:disabled) {
  background-color: #5568d3;
  transform: translateY(-2px);
}

.accept-btn:disabled {
  background-color: #ccc;
  cursor: not-allowed;
  transform: none;
}

.disclaimer-text {
  color: #666;
  font-size: 0.75rem;
  text-align: center;
}
</style>
